import React from 'react';
import { Clock, Shield, Briefcase, Heart } from 'lucide-react';

const KeyBenefitsSection = () => {
  const benefits = [
    {
      icon: Clock,
      text: "Moins de temps perdu à reconstruire l'historique médical.",
      color: "text-blue-600",
      bgColor: "bg-blue-100"
    },
    {
      icon: Shield,
      text: "Même en urgence, le vétérinaire a accès à l'historique santé.",
      color: "text-red-600",
      bgColor: "bg-red-100"
    },
    {
      icon: Briefcase,
      text: "Le dossier médical de votre animal vous suit partout.",
      color: "text-teal-600",
      bgColor: "bg-teal-100"
    }
  ];

  return (
    <section className="py-12 bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div 
                key={index}
                className="flex items-center gap-4 p-5 bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 hover:shadow-md transition-shadow"
              >
                <div className={`flex-shrink-0 w-12 h-12 ${benefit.bgColor} rounded-xl flex items-center justify-center`}>
                  <Icon className={`w-6 h-6 ${benefit.color}`} />
                </div>
                <p className="text-gray-700 dark:text-gray-300 font-medium leading-snug">
                  {benefit.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default KeyBenefitsSection;
